import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserView, MobileView } from 'react-device-detect'

ReactDOM.render(
  <>
    <BrowserView>
      <App />
    </BrowserView>
    <MobileView>
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <h2>
          <a
            href="https://makeresume.co"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              color: 'color: var(--font-color)',
              textDecoration: 'none',
            }}
          >
            makeresume.co
          </a>
        </h2>
      </div>
      <div
        style={{
          width: '50%',
          margin: '20px auto',
          backgroundColor: '#1e8ce9',
          color: 'white',
          padding: '10px',
          textAlign: 'center',
        }}
      >
        <h2> Sorry, the mobile version is not ready yet! </h2>
        <br />
        <a
          href="https://makeresume.co"
          style={{
            fontFamily: "'Montserrat', sans-serif",
            color: 'color: var(--font-color)',
            textDecoration: 'none',
            fontSize: '12px',
          }}
        >
          Back to makeresume.co
        </a>
      </div>
    </MobileView>
  </>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
